import Cookies from "js-cookie";

export const isCookieSet = (cookieName: string): boolean => {
  try {
    const cookie = Cookies.get(cookieName);
    return cookie === "true";
  } catch (error) {
    return false;
  }
};

export const isTrackEventLoggingCookieSet = (): boolean =>
  isCookieSet("track_event_logging_enabled");
export const isPriceTestingEnabledCookieSet = (): boolean =>
  isCookieSet("price_testing_enabled");
// [TODO][TrialBannerExperiment][AfterRelease] Remove this helper
export const isTrialBannerVariantACookieSet = (): boolean =>
  isCookieSet("trial_banner_variant_a");
export const isTrialBannerVariantBCookieSet = (): boolean =>
  isCookieSet("trial_banner_variant_b");
export const isWebsiteBuilderSplashScreenCookieSet = (): boolean =>
  isCookieSet("website_builder_splash_screen_enabled");
